(function () {

	angular
		.module('ngmvac')
		.controller('confirmacionController', ConfirmacionController);

	ConfirmacionController.$inject = ['$scope', '$window', '$filter', 'ReservationFactory', 'Cart', 'HotelFactory', 'ContentApiService', 'timeService', '$timeout', 'hours', '$http', '$log'];

	function ConfirmacionController($scope, $window, $filter, ReservationFactory, Cart, HotelFactory, ContentApiService, timeService, $timeout, hours, $http, $log) {
		var vm = this;
		vm.cart = Cart;
		vm.cart.config.editable = true;
		vm.cart.config.viewTotal = false;

		vm.hotelData = {};
		vm.rooms = [];
		vm.drivers = [];
		vm.represents = [];
		vm.titularSelected = false;
		vm.totalHotel = 0;
		vm.allPaxesInformation = false;
		vm.requireAllPaxesInformation = false;
		vm.comment = false;

		vm.terminos  =false;

        vm.modalPreView = {};
        vm.blockAmount = '';
		vm.extraRate = 0;
		vm.extraRateUpgraded = 0;
		vm.autoAdapter = {};
		vm.totalCP = 0;
		vm.pathImages = 'https://photos.hotelbeds.com/giata/';
		vm.pathImagesMedium = 'https://photos.hotelbeds.com/giata/medium/';
		vm.pathImagesBigger = 'https://photos.hotelbeds.com/giata/bigger/';
		vm.timeExpired = false;
		vm.counter = 0;
		vm.blok=true;
		vm.isCartLoaded = false;
		loader('block');
		vm.hourPU = {
			data_view: '10:00 am',
			data_value: '10:00',
		};
		vm.hourDO = {
			data_view: '10:00 am',
			data_value: '10:00',
		};
		$scope.data = {
			hoursPU: hours.list,
			hoursDO: hours.list,
		};
		
		vm.hourpickup = function() {
			let hPU = vm.hourPU.data_value;
			let hours = $scope.data.hoursPU;
			let copy = hours.filter(h => Date.parse(`01/01/2011 ${h.data_value}`) <= Date.parse(`01/01/2011 ${hPU}`));
			$scope.data.hoursDO = copy;
			vm.hourDO = vm.hourPU;
		};
		
		$.HSCore.components.HSGoTo.init('.js-go-to');
		$(".footer-base").addClass("d-sm-block");
		$(".footer-base").show();

		vm.reloadRoute = function(){
			console.log("funcion")
			$window.history.back()
		}

		/**
		 * This method set boolean flag
		 * is extra day or not.
		 */
		vm.checkExtraDay = function() {
			const pick = vm.hourPU;
			const drop = vm.hourDO;
			const datePick = Date.parse(`01/01/2011 ${pick.data_value}`);
			const dateDrop = Date.parse(`01/01/2011 ${drop.data_value}`);
			let isExtraDay = datePick < dateDrop;
			if (isExtraDay) {
				let cars = vm.cart.content.filter( (element) => element.type == 'auto');
				let car = cars[ cars.length - 1 ];
				if (vm.extraRateUpgraded == 0 ) {
					vm.extraRate = vm.cart.content[0].car.mcrRate;
				} else {
					vm.extraRate = vm.extraRateUpgraded;
				}
				vm.autoAdapter.extraRate = vm.extraRate;
				ReservationFactory.sendExtraRate('extraRate', vm.extraRate);
				vm.createCar(car);
			} else {
				vm.autoAdapter = {};
				vm.extraRate = 0;
				ReservationFactory.sendExtraRate('extraRate', 0);
			}
		};

		/**
		 * clone car object.
		 */
		vm.createCar = function (car) {
			let startDateCP = vm.cart.content[0].startDate;
			let endDateCP = vm.cart.content[0].endDate;
			vm.autoAdapter = {
				type: 'auto',
				extraRate: vm.extraRate,
				name: car.name,
				description: car.description,
				caminoImagen: car.link_imagen,
				proveedor: car.proveedor,
				categoryCode: car.categoryCode,
				categoryName: car.categoryName,
				startDate: startDateCP,
				endDate: endDateCP,
				idDatosDirectorioAbrir: car.idDatosDirectorioAbrir,
				idDatosDirectorioCerrar: car.idDatosDirectorioCerrar,
				images: car.images,
				imagesProveedor: car.imagesProveedor,
				price: car.price,
				content: [{
					price: 0,
					net: 0,
					adults: 0,
					amount: 1,
					tarifa: 0
				}],
				loaded: false,
				cotizador: car.cotizador
			};
		};

		vm.issues = [];

		vm.search = {};
		vm.driverCarCheckbox = false;

		$scope.$on('itemCartAdded', function (event, args) {
			vm.total = args.total;
		});

		function loader(type) {
            vm.loaderStyle = { display: type };
			if(type == 'block')
				$('#loader').show();
			else
				$('#loader').hide();
		}

		$scope.$on('cartLoaded', function (event, args) {
			vm.isCartLoaded = true;
			if(vm.cart.content.length == 0 ) {
				$window.location.href = "/";
			}
			setTimeout(function(){ 
			$('.upgradeCar').slick({
                slidesToShow: 3,
				slidesToScroll: 3,
				prevArrow: '<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev" ng-click="$ctrl.prevSlide()"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
            	nextArrow: '<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next" ng-click="$ctrl.nextSlide()"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings objec
                ]
			  });
			}, 1000);
			setTimeout(function(){ $('.showUpgrade').css('visibility', 'visible'); }, 1000);
			angular.element('#loaderStylereservacion').css({
				display: 'none'
			});

			angular.forEach(args.content, function (item) {
				if (item.type == 'hotel') {
					vm.ver1 = true;
					vm.hotelData = item;

					if(vm.hotelData.cancellationPenalty == "ALL"){
						vm.totalCP = vm.hotelData.price;
					}else{
						vm.totalCP = (vm.hotelData.price/ vm.hotelData.nights)* vm.hotelData.cancellationpenaltyDays;
					}

					var images = [];
					var auxImages = [];

					angular.forEach(vm.hotelData.content, function(room){
						angular.forEach(vm.hotelData.images, function(image){
							if(image.roomCode == room.roomCode){
								if(image.imageTypeCode == 'HAB'){
									images.push(image);
								}
							}

							if(image.imageTypeCode == 'GEN'){
								auxImages.push(image);
							}
						});
					});

					if(images.length > 0) { 
						vm.hotelData.roomsImages = images;
					} else {
						vm.hotelData.roomsImages = auxImages;
					}

					vm.iconocurrency(vm.hotelData.currency);
					vm.requireAllPaxesInformation = vm.allPaxesInformation = vm.hotelData.allPaxes;
					
					if (vm.hotelData.content.issues) {
						vm.makeIssues(vm.hotelData.content.issues);
					}
					
					$timeout(loader('none'), 2000);
				}

				if (item.type == 'auto') {
					vm.vuelo = true;
					// vm.ver1 = false;
					if(localStorage.getItem('cotizadorSeleccionado') == 1) {
						vm.drivers.push({name: item.name});
					}
				}

			});
			// $log.info("funciones");
			vm.makeRoomNode();
			//vm.makeRateComments();
			vm.makeRepresents();
			vm.makeVehiculoNode();

			timeService.init({
				callback: function (conteo) {
					vm.counter = conteo;
				},
				end: function () {
					HotelFactory.cancelOperation()
						.then(function () {
							console.info('exit');
						})
						.catch(function (err) {
							console.error(err.data);
						});
					vm.timeExpired = true;
				},
				initialCounting: vm.hotelData.check
			});

			angular.element('#loaderStylereservacion').css({
				display: 'none'
			});
		});

		$scope.$on('itemCartDeleted', function (event, args) {
			console.log(args, "args item deleted");

			if (args.item[0].type == 'auto') {
				vm.vuelo = false;
				vm.ver1 = true;
				// vm.drivers.splice(0,1);
			}
			setTimeout(function(){ $('.showUpgrade').css('visibility', 'visible'); console.log('fdsfdsf') }, 1000);
		});

		vm.cart.init();


		vm.addToCart = function(_auto,addCar){
			$('.showUpgrade').css('visibility', 'hidden')

            vm.modalPreView = _auto;
			var startDateCP = vm.cart.content[0].startDate;
			var endDateCP = vm.cart.content[0].endDate;
			auto = _auto.car;
			var autoAdapter = {
				type: 'auto',
				name: auto.nombreAuto,
				description: auto.descripccion,
				caminoImagen: auto.imagen,
				link_imagen: auto.link_imagen,
				proveedor: auto.id_proveedor,
				categoryCode: auto.id_categoria,
				categoryName: auto.categoria,
				startDate: startDateCP,
				endDate: endDateCP,
				idDatosDirectorioAbrir: auto.id_datos_directorio_abrir,//zoneName: '',
				idDatosDirectorioCerrar: auto.id_datos_directorio_cerrar, //destinationName: '',
				images: [{
					path: auto.imagen,
					imageTypeCode: 'GEN'
				}],
				imagesProveedor: [{
					path: ''
				}],
				price: _auto.diff,
				content: [{
					price: parseFloat(auto.publicRate),
					net: auto.tarifaNeta,
					adults: 0,
					amount: 1,
					tarifa: parseFloat(auto.publicRate)
				}],
				loaded: false,
				cotizador: {}
			};

			autoAdapter.cotizador.hora_pu = $('#horaRecoger').val();
			autoAdapter.cotizador.hora_do = $('#horaDejar').val();
			autoAdapter.cotizador.fhInicio = vm.cart.content[1].cotizador.fhInicio;
			autoAdapter.cotizador.fhFin = vm.cart.content[1].cotizador.fhFin;
			autoAdapter.cotizador.ubicacion = "Aeropuerto";
			autoAdapter.cotizador.ubicacion_do = "Aeropuerto";
			autoAdapter.cotizador.IATA = vm.cart.content[1].cotizador.IATA;

			$log.info(addCar);
            if (addCar){
				if(vm.extraRate > 0) {
					vm.extraRateUpgraded = _auto.car.mcrRate;
					vm.extraRate = vm.extraRateUpgraded;
					ReservationFactory.sendExtraRate('extraRate', vm.extraRate);
					autoAdapter.extraRate = vm.extraRate;
				}
                var element = angular.element('#ConfirmChangeCar');
                element.modal('hide');
                vm.cart.add(autoAdapter, isAdded());
            }else{
                $http.post('/block-amount', {
                    provider: vm.modalPreView.car.id_proveedor,
                    category: vm.modalPreView.car.categoria,
                }).then(function(response){
                    vm.blockAmount = response.data;
                });
                var element = angular.element('#ConfirmChangeCar');
                element.modal('show');
            }
		} 

		function isAdded() {
			console.log('success');
		}

		vm.makeIssues = function (issues) {
			var issuesAux = {};
			angular.forEach(issues, function (issue) {
				if (issue.issueType in issuesAux) {
					issuesAux[issue.issueType].push(issue.issueCode);
				} else {
					issuesAux[issue.issueType] = [];
					issuesAux[issue.issueType].push(issue.issueCode);
				}
			});

			HotelFactory.getIssues(issuesAux)
				.then(function (response) {
					vm.issues = response.data;
				})
				.catch(function (err) {
					console.log(err);
				});
		}

		/* vm.makeRateComments =  function () {
			HotelFactory.getRateComments()
				.then(function (response) {
					$log.info(response, "response");
					angular.forEach(vm.rooms, function (room) {
						angular.forEach(response.data, function (rateComment) {

							if (rateComment.key == room.rateKey) {
								room.rateComments = rateComment;
							}
						});
					});

					angular.forEach(vm.hotelData.content, function (room) {
						angular.forEach(response.data, function (rateComment) {
							if (rateComment.key == room.rateKey) {
								if (rateComment.rateComments.length > 0) {
									vm.isThereRateComments = true;
									var content = '';
									angular.forEach(rateComment.rateComments, function (com) {
										content += com.description;
									});
									room.rateComments = content;
								}
							}
						});
					});
				})
				.catch(function (err) {console.log(err)});
		} */

		vm.imageGroup = function (hotel) {
			var imagenes = [];

			if (hotel.content.images) {
				hotel.fotoActual = hotel.content.images[0].path;
				var limSup = hotel.content.images.length;
				for (var __i = 0; __i < limSup; __i++) {
					imagenes.push(hotel.content.images[__i].path);
				}
				hotel.imagenes = imagenes;
				Array.prototype.unique = function (a) {
					return function () {
						return this.filter(a)
					};
				}(function (a, b, c) {
					return c.indexOf(a, b + 1) < 0;
				});

				hotel.imagenes = hotel.imagenes.unique();
			}
		}

		vm.makeRoomNode = function () {

			angular.forEach(vm.hotelData.content, function (item, indexItem) {
				vm.totalHotel += parseFloat(item.price);

				for (var _i = 1; _i <= item.amount; _i++) {

					var pa = {
						rateKey: item.rateKey,
						rooms: item.amount,
						roomName: item.name,
						// boardCode: item.boardCode,
						// tarifaNeta: item.net,
						adults: item.adults,
						// children: item.children,
						paxes: []
					};

					for (var ai = 0; ai < item.adults; ai++) {
						pa.paxes.push({
							roomId: _i,
							type: 'AD'
						});
					}

					if (item.children > 0) {
						var childrenAges = item.childrenAges.split(',');
						for (var ci = 0; ci < item.children; ci++) {
							pa.paxes.push({
								roomId: _i,
								type: 'CH',
								age: childrenAges[ci]
							});
						}
					}

					vm.rooms.push(pa);
					
				}
				
			});

		}

		vm.makeVehiculoNode = function () {
			if(localStorage.getItem('cotizadorSeleccionado') == 1) {
				angular.forEach(vm.drivers, function(driver) {
					driver.driverName = '';
					driver.driverLastname = '';
				});
			}
		}

		vm.changeDriverCarCheckbox = function () {
			if (vm.driverCarCheckbox) {
				vm.drivers[0].driverName = vm.rooms[0].paxes[0].name;
				vm.drivers[0].driverLastname = vm.rooms[0].paxes[0].surname;
			} else {
				vm.drivers[0].driverName = '';
				vm.drivers[0].driverLastname = '';
			}
		}

		vm.makeRepresents = function () {
			angular.forEach(vm.hotelData.content, function (item) {
				for (var _i = 1; _i <= item.amount; _i++) {
					var pa = {
						rateKey: item.rateKey,
						roomName: item.name,
						adults: item.adults,
						children: item.children,
						name: '',
						surname: '',
						phone: '',
						email: ''
					};
					vm.represents.push(pa);
				}
			})
			// console.log(vm.represents,'representan');
		}

		vm.press = function (clickEvent) {
			if (vm.allPaxesInformation) {
					$http.post('/black-list', {
							email: vm.holder_.email,
							telefono: vm.holder_.phone,
							cel: vm.holder_.phone,
							nombre:  vm.rooms[0].paxes[0].name,
							apellido: vm.rooms[0].paxes[0].surname,

					}).then(function(response){
							if(response.data.length !=0){
									$window.location.href = '/';
							}
					}).catch(function (error) {
							console.log(error.data, error.status);
					});
			}else{
					$http.post('/black-list', {
							email: vm.represents[0].email,
							telefono: vm.represents[0].phone,
							cel: vm.represents[0].phone,
							nombre: vm.represents[0].name,
							apellido: vm.represents[0].surname,

					}).then(function(response){
							if(response.data.length !=0){
									$window.location.href = '/';
							}
					}).catch(function (error) {
							console.log(error.data, error.status);
					});
			}
			if (vm.extraRate !== 0) {
				console.log('here 1');
				vm.cart.add(vm.autoAdapter, function(data) {
					angular.element(clickEvent.target).append(' <i class="fa fa-spin fa-spinner"></i>');
					vm.holder = {};
					if (vm.allPaxesInformation) {
						vm.holder.name = vm.rooms[0].paxes[0].name; //vm.holderNames.name;
						vm.holder.surname = vm.rooms[0].paxes[0].surname; //vm.holderNames.surname;
						vm.holder.email = vm.holder_.email;
						vm.holder.phone = vm.holder_.phone;
					} else {
						vm.holder.name = vm.represents[0].name;
						vm.holder.surname = vm.represents[0].surname;
						vm.holder.email = vm.represents[0].email;
						vm.holder.phone = vm.represents[0].phone;
					}
					if (vm.vuel) {
						vm.holder.no_vuelo = vm.vuel.origen_vuelo;
						vm.holder.aerolinea = vm.vuel.aerolinea;
						vm.holder.arrivoHora = vm.vuel.hora_arribo;
						vm.holder.origenVuelo = vm.vuel.num_vuelo;
					} else {
						vm.holder.no_vuelo = "";
						vm.holder.aerolinea = "";
						vm.holder.arrivoHora = "";
						vm.holder.origenVuelo = "";
					}

					var car = {
						pickup_hour: $('#horaRecoger').val(),
						dropoff_hour: $('#horaDejar').val()
					}

					var data = {
						holder: vm.holder,
						rooms: vm.rooms,
						drivers: vm.drivers,
						allPaxesInformation: vm.allPaxesInformation,
						comment: vm.comment,
						commentContent: vm.commentContent || '',
						car : car,
						extraRateData: vm.autoAdapter,
						cancellationpenaltyDays : vm.hotelData.cancellationpenaltyDays
					};
					if (!vm.allPaxesInformation) {
						data.represents = vm.represents
					}

					ReservationFactory.addConfirmation(data)
						.then(function (response) {
							if (response.status == 200) {
								var path = response.data.path;
								// let vehicles = vm.cart.get();
								// let vehicle = vehicles.find(element => element.hasOwnProperty('extraRate'));
								// let index = vehicles.indexOf(vehicle);
								// vm.cart.remove(index);
								try {
									HotelFactory.deleteLocalStorage();
									// console.log('LS eliminado');
								} catch (err) {
									console.log(err);
								}
								
								$window.location.href = '/' + path;
							}
						})
						.catch(function (error) {
							console.log(error.data, error.status);
						});
				});
			} else {
				console.log('here 2');
				angular.element(clickEvent.target).append(' <i class="fa fa-spin fa-spinner"></i>');
				vm.holder = {};
				if (vm.allPaxesInformation) {
					vm.holder.name = vm.rooms[0].paxes[0].name; //vm.holderNames.name;
					vm.holder.surname = vm.rooms[0].paxes[0].surname; //vm.holderNames.surname;
					vm.holder.email = vm.holder_.email;
					vm.holder.phone = vm.holder_.phone;
				} else {
					vm.holder.name = vm.represents[0].name;
					vm.holder.surname = vm.represents[0].surname;
					vm.holder.email = vm.represents[0].email;
					vm.holder.phone = vm.represents[0].phone;
				}
				if (vm.vuel) {
					vm.holder.no_vuelo = vm.vuel.origen_vuelo;
					vm.holder.aerolinea = vm.vuel.aerolinea;
					vm.holder.arrivoHora = vm.vuel.hora_arribo;
					vm.holder.origenVuelo = vm.vuel.num_vuelo;
				} else {
					vm.holder.no_vuelo = "";
					vm.holder.aerolinea = "";
					vm.holder.arrivoHora = "";
					vm.holder.origenVuelo = "";
				}

				var car = {
					pickup_hour: $('#horaRecoger').val(),
					dropoff_hour: $('#horaDejar').val()
				}

				var data = {
					holder: vm.holder,
					rooms: vm.rooms,
					drivers: vm.drivers,
					allPaxesInformation: vm.allPaxesInformation,
					comment: vm.comment,
					commentContent: vm.commentContent || '',
					car : car,
					cancellationpenaltyDays : vm.hotelData.cancellationpenaltyDays
				};
				
				if (!vm.allPaxesInformation) {
					data.represents = vm.represents
				}
				ReservationFactory.addConfirmation(data)
					.then(function (response) {
						if (response.status == 200) {
							var path = response.data.path;
							// let vehicles = vm.cart.get();
							// let vehicle = vehicles.find(element => element.hasOwnProperty('extraRate'));
							// let index = vehicles.indexOf(vehicle);
							// vm.cart.remove(index);
							try {
								HotelFactory.deleteLocalStorage();
								console.log('LS eliminado');
							} catch (err) {
								console.log(err);
							}
							
							$window.location.href = '/' + path;
						}
					})
					.catch(function (error) {
						console.log(error.data, error.status);
					});
			}
			
		}

		vm.iconocurrency = function (currency) {


			if (currency == 'USD') {
				$scope.iconocurrency = "$";
			} else if (currency == 'EUR') {
				$scope.iconocurrency = "€";
			} else if (currency == 'GBP') {
				$scope.iconocurrency = "£";
			} else if (currency == 'MXN') {
				$scope.iconocurrency = "$";
			}


		}

		vm.submitReservation = function (code, package) {

			var reservationData = {
				hotelCode: code,
				roomsSelected: []
			};

			angular.forEach(package.rooms, function (room, indexRoom) {
				reservationData.roomsSelected.push({
					roomCode: room.roomCode,
					rateKey: room.rateKey
				});
			});

			ReservationFactory.addToSession(reservationData)
				.then(function (response) {
					$window.location.href = "/hotel/reservacion"
				})
				.catch(function (error) {
					console.log(error);
				});
		}

		vm.hotelSelected = function (clickEvent, hotel) {
			var DOMElement = angular.element(clickEvent.target);
			DOMElement.append(' <i class="fa fa-spin fa-spinner"></i>');

			if (HotelFactory.isLocalStorageAvailable()) {
				localStorage.setItem('hotelSelected', JSON.stringify(hotel));
				localStorage.setItem('search', JSON.stringify(vm.search));
			}

			$window.location.href = "/hotel/details/" + hotel.tokenName;
		}

	}

})();
